//Custom date filter function
export const filterParams = {
    comparator: function (filterLocalDateAtMidnight, cellValue) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      dateAsString = new Date(dateAsString).toDateString();
      var dateParts = dateAsString.split(" ");
      var cellDate = new Date(`${dateParts[3]} ${dateParts[1]} ${dateParts[2]}`);
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
    },
    buttons: ['reset'],
    browserDatePicker: true,
    minValidYear: 2000,
  };


//Custom date sort function
  export const dateComparator = (value1, value2) => {
    let date1 = new Date(value1);
    let date2 = new Date(value2);
    if (isNaN(date1) || isNaN(date2)) {
      if (isNaN(date1) && isNaN(date2)) return 0;
      return isNaN(date1) ? -1 : 1;
    }
    if (date1 === date2) return 0;
    return date1 > date2 ? 1 : -1;
  };

//Filter to check the undefine value
  export const comparator = (value1, value2) => {
    let comparatorValue1 = value1 && value1.value ? value1.value : "";
    let comparatorValue2 = value2 && value2.value ? value2.value : "";
    if (
      typeof comparatorValue1 == "string" &&
      !isNaN(parseFloat(comparatorValue1))
    )
      comparatorValue1 = parseFloat(comparatorValue1);
    if (
      typeof comparatorValue2 == "string" &&
      !isNaN(parseFloat(comparatorValue2))
    )
      comparatorValue2 = parseFloat(comparatorValue2);
    if (comparatorValue1 === comparatorValue2) return 0;
    return comparatorValue1 > comparatorValue2 ? 1 : -1;
  };